// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"606":"2998d897","964":"668b2e35"}[chunkId] + ".chunk.js";
};